import React from "react";
import { motion } from "framer-motion";
import { MessageCircle, Instagram } from "lucide-react";
import { LINKS } from "@/data/content";

const open = (url) => window.open(url, "_blank", "noopener,noreferrer");

// Sticky bottom bar — mobile only — always keeps the two CTAs one tap away
const MobileCTABar = () => (
  <motion.div
    data-testid="mobile-cta-bar"
    initial={{ y: 100 }}
    animate={{ y: 0 }}
    transition={{ delay: 1.8, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
    className="md:hidden fixed bottom-0 inset-x-0 z-50 p-3 glass border-t border-white/10"
  >
    <div className="flex gap-3">
      <button
        data-testid="mobilebar-whatsapp-button"
        onClick={() => open(LINKS.whatsapp)}
        className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-gold text-black font-semibold py-3 text-sm"
      >
        <MessageCircle className="w-4 h-4" /> WhatsApp
      </button>
      <button
        data-testid="mobilebar-instagram-button"
        onClick={() => open(LINKS.instagram)}
        className="flex-1 inline-flex items-center justify-center gap-2 rounded-full glass text-white font-medium py-3 text-sm border border-white/15"
      >
        <Instagram className="w-4 h-4 text-gold" /> Instagram
      </button>
    </div>
  </motion.div>
);

export default MobileCTABar;
